export function useFlux() {
  // TODO: Replace useRoute to useSignatureRequestKind composable
  const { signatureRequestKind } = useRoute().params;
  const availableKinds = ['notarial', 'flux'];

  if (!availableKinds.includes(signatureRequestKind)) {
    showError(
      createError({
        statusCode: 404,
        fatal: true,
        cause: 'Not found',
        statusMessage: 'Invalid signature request kind',
      }),
    );
  }

  const isFlux = signatureRequestKind === 'flux';

  return { isFlux };
}
